<template>
    <div class="">
        <input type="hidden" name="config" :value="JSON.stringify(config)">

        <timing-period-module :dto="config.timing" :options="options" :compare="false"></timing-period-module>

        <div class="card shadow mb-3">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Optionen</h6>
            </div>
            <div class="card-body">

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">
                        <i class="fas fa-info-circle text-muted"
                           style=""
                           data-toggle="tooltip"
                           data-placement="top"
                           :title="$info['calculation.columns']"></i>
                        Anzuzeigende Spalten
                    </legend>

                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label><b>PZN</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-name"
                                           v-model="config.pznName">
                                    <label class="form-check-label" for="pzn-name">
                                        Artikelname
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-menge-einheit"
                                           v-model="config.pznMengeEinheit">
                                    <label class="form-check-label" for="pzn-menge-einheit">
                                        Menge und Einheit
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-dar"
                                           v-model="config.pznDar">
                                    <label class="form-check-label" for="pzn-dar">
                                        Darreichungsform
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-anbieter"
                                           v-model="config.pznAnbieter">
                                    <label class="form-check-label" for="pzn-anbieter">
                                        Anbieter
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label><b>BGA</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="bga-name"
                                           v-model="config.bgaNameCity">
                                    <label class="form-check-label" for="bga-name">
                                        Name und Ort
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="bga-dates"
                                           v-model="config.bgaDates">
                                    <label class="form-check-label" for="bga-dates">
                                        Start- und Enddatum
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label><b>Sell-In</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="einkauf-absatz"
                                           v-model="config.einkaufAbsatz">
                                    <label class="form-check-label" for="einkauf-absatz">
                                        Absatz
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="einkauf-umsatz"
                                           v-model="config.einkaufUmsatz">
                                    <label class="form-check-label" for="einkauf-umsatz">
                                        Umsatz
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label><b>Sell-Out</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="verkauf-absatz"
                                           v-model="config.verkaufAbsatz">
                                    <label class="form-check-label" for="verkauf-absatz">
                                        Absatz
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="verkauf-umsatz"
                                           v-model="config.verkaufUmsatz">
                                    <label class="form-check-label" for="verkauf-umsatz">
                                        Umsatz
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">Sell-In</legend>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['sellIn.mode']"></i>
                            <b>Modus</b>
                        </label>
                        <select class="form-control" v-model="config.sellInMode">
                            <option value="all-split">Anbieter und Großhandel - Getrennt</option>
                            <option value="all-sum">Anbieter und Großhandel - Summe</option>
                            <option value="anbieter">Anbieter</option>
                            <option value="grosshandel">Großhandel</option>
                        </select>
                        <div class="form-check mt-2" v-if="config.sellInMode !== 'all-sum'">
                            <input class="form-check-input" type="checkbox" value="" id="sell-in-mode-switch"
                                   v-model="config.sellInModeSwitch">
                            <label class="form-check-label" for="sell-in-mode-switch">
                                <i class="fas fa-info-circle text-muted"
                                   style=""
                                   data-toggle="tooltip"
                                   data-placement="top"
                                   :title="$info['sellIn.modeSwitch']"></i>
                                Überweiser in Direktgeschäft
                            </label>
                        </div>
                    </div>
                </fieldset>

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">Sell-Out</legend>

                    <div class="form-check my-2">
                        <input class="form-check-input" type="checkbox" value="" id="sell-out-tax"
                               v-model="config.sellOutRemoveTax">
                        <label class="form-check-label" for="sell-out-tax">
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['sellOut.removeTax']"></i>
                            Mwst. herausrechnen
                        </label>
                    </div>
                </fieldset>

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">Weitere Seiten</legend>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['pages.coops']"></i>
                            <b>Kooperationen</b>
                        </label>
                        <select class="form-control" v-model="config.pageCoops">
                            <option value="disabled">Deaktiviert</option>
                            <option value="split">Getrennte Kooperationen</option>
                        </select>
                    </div>
                </fieldset>

                <fieldset class="border px-3" v-if="!(options.disabledFeatures || []).includes('panel_settings')">
                    <legend class="w-auto">Prozentregelung</legend>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['panel.panelPercent']"></i>
                            <b>Panelgröße</b>
                        </label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Prozent</span>
                            </div>
                            <input type="text" class="form-control" placeholder="100" v-model="config.panelPercent">
                        </div>
                    </div>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['panel.panelBase']"></i>
                            <b>Berechnungsgrundlage</b>
                        </label>
                        <select class="form-control" v-model="config.panelBase">
                            <option value="sell-out">Sell Out</option>
                            <option value="sell-in">Sell In</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['panel.panelPeriod']"></i>
                            <b>Startdatum Modus</b>
                        </label>
                        <select class="form-control" v-model="config.panelPeriod">
                            <option value="full">Gesamtzeitraum</option>
                            <option value="quarterly-start">Quartalsweise - Anfang</option>
                            <option value="quarterly-middle">Quartalsweise - Mitte</option>
                            <option value="quarterly-end">Quartalsweise - Ende</option>
                            <option value="monthly">Monatlich</option>
                        </select>
                    </div>
                </fieldset>

            </div>
        </div>

        <filtering-module :dto="config.filtering" :options="options"></filtering-module>

        <pre v-if="$debugEnabled">{{ JSON.stringify(config, 0, 2) }}</pre>
    </div>
</template>

<script>

import TimingPeriodModule from "../Modules/TimingPeriodModule";
import FilteringModule from "../Modules/FilteringModule";

export default {
    components: {FilteringModule, TimingPeriodModule},
    props: {
        dto: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            config: this.dto
        };
    }
}
</script>
